export const LOGO_URL =
  "https://static.prod-images.emergentagent.com/jobs/1ccbfdc3-b11d-49ab-95cd-85732fa51711/images/7d93de30a9b85f55a5277e7f028d186173e1d38e3807f6421b5487dd2b3ab422.jpeg";

export const LOGIN_HERO =
  "https://highbergsolution.ro/wp-content/uploads/2025/07/Highberg-Solution-Rezervoare-Tanks-Projects-Hero2.png";

export const TANK_COVER =
  "https://highbergsolution.ro/wp-content/uploads/2025/08/Highberg-Rezervoare_Tanks-hgs1671-norvegia_namsos-prjjj-001-300x300.jpg";
